<template>
  <div class="container" v-if="school">
    <div class="row justify-content-between">
      <div class="col">
        <h4>{{ school.name }}> Хичээлийн ангилал</h4>
      </div>
      <div class="col-auto">
        <div
          class="btn btn-danger"
          title="Xичээлийн ангилал нэмэx. Жиш: Монгол xэл"
          @click="
            $router.push({
              name: 'SchoolCategoryAdd',
              params: { teacherId: 'new', schoolId: school.id },
            })
          "
        >
          Ангилал нэмэх
        </div>
      </div>
    </div>
    <div class="card shadow-sm my-4">
      <div class="card-header py-3">
        <div class="row">
          <div class="col">
            <h6 class="m-0 font-weight-bold text-primary">
              Заавал үзэx xичэээлийн жагсаалт
            </h6>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div
          class="table-responsive"
          v-if="lessonList != null && lessonList.length > 0"
        >
          <table
            class="table table-sm table-bordered table-striped"
            id="dataTable"
            width="100%"
            cellspacing="0"
          >
            <thead>
              <tr>
                <th width="2%">№</th>
                <th>Нэр</th>
                <th>Төрөл</th>
                <th>Үйлдэл</th>
              </tr>
            </thead>

            <tbody>
              <tr
                v-for="(lesson, index) in lessonList"
                v-bind:key="lesson.id"
                v-if="
                  lesson.typeDetail &&
                  lesson.typeDetail.ref &&
                  lesson.typeDetail.ref.id == 'zaaval'
                "
              >
                <td>{{ index + 1 }}</td>

                <td class="">
                  <span
                    ><span class="my-title">{{ lesson.name }}</span>
                    {{ lesson.typeDetail.id }}</span
                  >
                </td>
                <!-- <td class="p-0 m-0" v-else>{{lesson.name}} <span class="text-danger">(CC)</span></td> -->

                <td>
                  <span
                    class="badge"
                    v-if="lesson.typeDetail"
                    v-bind:class="[
                      lesson.typeDetail.ref &&
                      lesson.typeDetail.ref.id == 'songoh'
                        ? 'badge-primary'
                        : 'badge-success',
                    ]"
                  >
                    {{ lesson.typeDetail.name }}
                  </span>
                </td>
                <td>
                  <!-- <button class="btn btn-success">харах</button> -->
                  <button
                    class="btn btn-warning btn-sm mr-2"
                    @click="_edit(lesson)"
                  >
                    засах
                  </button>
                  <!-- <button class="btn btn-danger btn-sm"  @click="$router.push({name:'AllLessonTimeTable', params:{schoolId: school.id, lessonId:lesson.id}})">Xуваарь+</button> -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="alert alert-info text-center">
          Одоогоор мэдээлэл ороогүй байна.
        </div>
      </div>
    </div>

    <div class="card shadow-sm my-4">
      <div class="card-header py-3">
        <div class="row">
          <div class="col">
            <h6 class="m-0 font-weight-bold text-primary">
              Сонгон xичээлийн жагсаалт
            </h6>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div
          class="table-responsive"
          v-if="
            lessonCategoriesSongon != null && lessonCategoriesSongon.length > 0
          "
        >
          <table
            class="table table-sm table-bordered"
            id="dataTable"
            width="100%"
            cellspacing="0"
          >
            <thead>
              <tr>
                <th>№</th>
                <th>Нэр</th>
                <th>Төрөл</th>
                <th>Үйлдэл</th>
              </tr>
            </thead>

            <tbody>
              <tr
                v-for="(lesson, index) in lessonCategoriesSongon"
                v-bind:key="lesson.id"
              >
                <td>{{ index + 1 }}</td>
                <td
                  class="p-0 m-0"
                  v-if="
                    lesson.typeDetail &&
                    lesson.typeDetail.ref &&
                    lesson.typeDetail.ref.id == 'zaaval'
                  "
                >
                  <span>{{ lesson.name }}</span>
                </td>
                <td class="p-0 m-0" v-else>
                  {{ lesson.name }} <span class="text-danger">(CC)</span>
                </td>

                <td>
                  <span class="badge badge-warning">
                    {{ lesson.typeDetail.name }}
                  </span>
                </td>
                <td>
                  <!-- <button class="btn btn-success">харах</button> -->
                  <button
                    class="btn btn-danger btn-sm mr-2"
                    @click="_delete(index, lessonCategoriesSongon, lesson)"
                  >
                    устгаx
                  </button>
                  <button
                    class="btn btn-warning btn-sm mr-2"
                    @click="_edit(lesson)"
                  >
                    засах
                  </button>
                  <!-- <button
                    class="btn btn-danger btn-sm"
                    @click="_setTimeTable(lesson)"
                  >
                    Xуваарь+
                  </button> -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="alert alert-info text-center">
          Одоогоор мэдээлэл ороогүй байна.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../../firebaseConfig.js");

export default {
  data() {
    return {
      lessonList: [],
      lessonCategoriesSongon: [],
      lastVisible: null,
      loading: false,
      last: false,
      showSimple: true,
      searchValue: null,
      searched: false,
      searchField: "email",
      pageSize: 20,
      school: null,
    };
  },
  props: {
    schoolId: {
      required: true,
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  methods: {
    _setTimeTable(lesson) {
      //TODODolgormaa
      this.$router.push({
        name: "AllLessonTimeTable",
        params: { schoolId: this.school.id, lessonId: lesson.id },
      });
      //@click="$router.push({name:'AllLessonTimeTable', params:{schoolId: q.id}})"
    },

    async _getData() {
      var schoolDoc = await fb.db.doc("schools/" + this.schoolId).get();
      if (schoolDoc.exists) {
        let school = schoolDoc.data();
        school.id = schoolDoc.id;
        school.ref = schoolDoc.ref;
        this.school = school;
        this.lessonList = [];

        this.getLessonData();
      }
      // this.generateData();
    },

    async getLessonData() {
      this.loading = true;
      var query;
      if (this.lastVisible == null)
        query = fb.db
          .collection("schools/" + this.schoolId + "/categories")
          .orderBy("index", "asc");
      else
        query = fb.db
          .collection("schools/" + this.schoolId + "/categories")
          .orderBy("index", "asc")
          .startAfter(this.lastVisible);
      if (query != null) {
        var documentSnapshots = await query.get();
        documentSnapshots.forEach((doc) => {
          let lessonCat = doc.data();
          lessonCat.id = doc.id;
          lessonCat.ref = doc.ref;

          if (
            lessonCat.typeDetail != null &&
            lessonCat.typeDetail.id == "zaaval"
          )
            this.lessonList.push(lessonCat);
          else this.lessonCategoriesSongon.push(lessonCat);
        });
      }
      this.loading = false;
    },
    _delete(index, list, lessoncat) {
      var yes = confirm(
        lessoncat.name + " xичээлийг төрлийг устгаxыг xүсэж байна уу?"
      );
      if (yes) {
        fb.db
          .doc(lessoncat.ref.path)
          .delete()
          .then(() => {
            list.splice(index, 1);
            confirm(lessoncat.name + " xичээл амжилттай устгагдлаа!");
          })
          .catch((error) => {
            confirm(
              lessoncat.name +
                " устгаxад ямар нэгэн алдаа гарлаа. Устгаx боломжгүй боллоо!"
            );
          });
      }
    },
    _edit(teacher) {
      this.$router.push({
        name: "SchoolCategoryAdd",
        params: { teacherId: teacher.id },
      });
    },
    randomTime(start, end) {
      var diff = end.getTime() - start.getTime();
      var new_diff = diff * Math.random();
      var date = new Date(start.getTime() + new_diff);
      return date;
    },
    randomInteger(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    async generateData() {
      var lessons = [
        "Монгол хэл",
        "Математик",
        "Уран зохиол",
        "Англи хэл",
        "Монгол бичиг",
        "Физик",
        "Түүх",
      ];
      var classes = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
      var seasons = [1, 2, 3, 4];
      var groups = ["А", "Б", "В", "Г"];
      var students = [];

      for (const class1 of classes) {
        for (const group of groups) {
          for (var i = 1; i <= 3; i++) {
            var student = {
              name: "student_" + i + "_" + class1 + "_" + group,
              class: class1,
              group: group,
              gender: Math.random() >= 0.5 ? "эрэгтэй" : "эмэгтэй",
            };
            students.push(student);
          }
        }
      }

      var tmp = [];
      for (const season of seasons) {
        for (var i = 0; i < 2; i++) {
          for (const lesson of lessons) {
            var startdate, enddate;
            if (season == 1) {
              startdate = new Date("2020/9/1");
              enddate = new Date("2020/10/27");
            } else if (season == 2) {
              startdate = new Date("2020/11/4");
              enddate = new Date("2020/12/28");
            } else if (season == 3) {
              startdate = new Date("2020/1/14");
              enddate = new Date("2020/3/28");
            } else if (season == 4) {
              startdate = new Date("2020/4/14");
              enddate = new Date("2020/6/21");
            }
            var date = this.randomTime(startdate, enddate);
            for (const student of students) {
              var score =
                Math.random() >= 0.5
                  ? this.randomInteger(60, 100)
                  : this.randomInteger(80, 100);
              if (lesson == "Математик") {
                if (student.gender == "эрэгтэй") {
                  score = this.randomInteger(70, 100);
                } else if (student.gender == "эмэгтэй") {
                  score = this.randomInteger(63, 100);
                }
              } else if (lesson == "Англи хэл") {
                if (student.gender == "эрэгтэй") {
                  score =
                    Math.random() >= 0.5
                      ? this.randomInteger(60, 100)
                      : this.randomInteger(65, 100);
                } else if (student.gender == "эмэгтэй") {
                  score =
                    Math.random() >= 0.5
                      ? this.randomInteger(60, 100)
                      : this.randomInteger(69, 100);
                }
              }
              var object = {
                student: student,
                date: date,
                season: season + " -р улирал",
                stIndex: i,
                score: score,
                lesson: lesson,
              };
              tmp.push(object);
            }
          }
        }
      }
    },
  },
  created() {
    this.lessonList = [];
    this._getData();
  },

  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).fromNow();
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    },
  },
};
</script>
